import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { AbsolutePseudo, focusProps } from '../../../theme/utils';

export const radioTheme: ThemeOptions['components'] = {
  MuiRadio: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        '&.DsRadio-size': {
          '&Medium': {
            fontSize: '20px',
          },
          '&Small': {
            fontSize: '16px',
            '&.Mui-checked .RadioIconBase': {
              // Antialiasing issue
              borderWidth: 'thick',
            },
          },
        },
        padding: 0,
        width: '1em',
        height: '1em',
        '& .RadioIconBase': {
          borderRadius: tokens.theme.radius.full,
          boxSizing: 'border-box',
          transition: 'height ease-in-out 0.1s',
          width: '1em',
          height: '1em',
        },
        '&.Mui-checked': {
          border: 'none',
          '&:not(.Mui-disabled)': {
            color: tokens.theme.bg.selection.primary,
            '&:hover': {
              color: tokens.theme.bg.selection.primaryHover,
            },
            '&:active': {
              color: tokens.theme.bg.selection.primaryActive,
            },
          },
          '& .RadioIconBase': {
            color: 'inherit',
            backgroundColor: 'unset',
            border: 'solid currentColor 0.3em',
          },
        },

        '&:not(.Mui-checked)': {
          backgroundColor: 'unset',
          '& .RadioIconBase': {
            backgroundColor: 'inherit',
            border: `1px solid ${tokens.theme.border.structural.neutral}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          '&:hover .RadioIconBase': {
            borderColor: tokens.theme.border.action.neutralHover,
          },
          '&.Mui-disabled .RadioIconBase': {
            backgroundColor: tokens.theme.disabled.surface,
            borderColor: tokens.theme.disabled.border,
          },
        },

        '&.Mui-disabled': {
          color: tokens.theme.disabled.bg,
        },

        '&:active .RadioIconBase': {
          height: 'calc(1em - 2px)',
        },

        '&.Mui-focusVisible .RadioIconBase:after': {
          ...AbsolutePseudo,
          ...focusProps(),
          borderRadius: 'inherit',
        },
      },
    },
  },
};
